import ApiService from "@/utils/api.service";

export default {
    list(context) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("service")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    create(context, service) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("service", service)
                .then(({ data }) => {
                    //context.commit("setService", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    get(context, serviceId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("service/" + serviceId)
                .then(({ data }) => {
                    context.commit("setService", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    update(context, service) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" + service.id, service)
                .then(({ data }) => {
                    context.commit("setService", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

    activate(context, serviceId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" + serviceId + "/activate")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    desactivate(context, serviceId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" + serviceId + "/desactivate")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    updateField(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" +
                params.serviceId +
                "/step/" +
                params.stepId +
                "/block/" +
                params.blockId +
                "/field/" +
                params.fieldId, params.field)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });

        })
    },
    deleteBlock(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.delete("service/" +
                params.step.services_id +
                "/step/" +
                params.step.id +
                "/block/" +
                params.block.id)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });

        })
    },
    getApiList(context) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("service-api").then(({ data }) => {
                context.commit("setServiceApi", data);
                resolve(data);
            }).finally(() => {
                context.dispatch("app/setLoading", false, { root: true });
            });
        })
    },
    cleanService(context) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" + context.state.currentService.id + "/clean")
                .then(() => {
                    resolve();
                })
                .catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    setCurrentService(context, service) {
        context.commit("setCurrentService", service);
    },
    getAvailableApiFields(context, params) {
        return new Promise(resolve => {
            ApiService.get("service/" + params.step.services_id + "/step/" + params.step.id + "/block/" + params.block.id + "/api-available-fields").then(({ data }) => {
                resolve(data);
            })
        })
    },
    getServiceTypes(context) {

        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("service-type").then(({ data }) => {
                context.commit("setServiceTypes", data);
                resolve(data);
            }).finally(() => {
                context.dispatch("app/setLoading", false, { root: true });
            });
        })

    },
    saveGroupOptions(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" +
                params.serviceId +
                "/step/" +
                params.stepId +
                "/block/" +
                params.blockId +
                "/field-group"
                , params.model)
                .then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });

        })
    },
    up(context, serviceId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" + serviceId + "/up")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    down(context, serviceId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("service/" + serviceId + "/down")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },

}